import type { GameRuntime, GameRuntimeConfig, GameRuntimeEvents, GameRuntimeFactory } from '@adgf/game-engine';
import { ReactionGame } from './ReactionGame';
export { ReactionGame } from './ReactionGame';
export { default } from './manifest';
export { default as manifest } from './manifest';

/**
 * Factory used by the Dynamic Game Loader to create a fresh runtime
 * instance for this game. Each play session gets its own instance.
 */
export const createRuntime: GameRuntimeFactory = (
  config: GameRuntimeConfig,
  events?: GameRuntimeEvents,
): GameRuntime => {
  return new ReactionGame(config, events);
};
